import { ErrorBoundary, SearchProvider, WithSearch } from '@elastic/react-search-ui';
import { Layout } from '@elastic/react-search-ui-views';
import { SearchDriverOptions } from "@elastic/search-ui";
import ElasticsearchAPIConnector from "@elastic/search-ui-elasticsearch-connector";
import { elasticPrimaryConfig } from "@scripts/frontend/utils/elastic-client";
import { ElasticBlogResult } from "@scripts/frontend/types/elastic-blog-result";
import InsightsCard from "@scripts/frontend/insights/components/InsightsCard";
import FeaturedPanel from "@scripts/frontend/insights/components/featuredPanel";
import InsightsRow from "@scripts/frontend/insights/components/InsightsRow";

interface Props {
  numberToShow: string;
  baseUrl: string;
}

const elasticConfig = (numberToShow: string): SearchDriverOptions => ({
  alwaysSearchOnInitialLoad: true,
  trackUrlState: true,
  initialState: {
    sortField: 'date_published',
    sortDirection: 'desc',
    resultsPerPage: parseInt(numberToShow, 10),
  },
  searchQuery: {
    result_fields: {
      title: {
        raw: {},
      },
      color_theme: {
        raw: {},
      },
      slug: {
        raw: {},
      },
      date_published: {
        raw: {},
      },
      content_type: {
        raw: {},
      },
      featured_image: {
        raw: {},
      },
      featured_video: {
        raw: {},
      },
      logo: {
        raw: {}
      },
      excerpt: {
        raw: {}
      },
      time_to_read: {
        raw: {}
      },
    },
    disjunctiveFacets: [
      'authors.enum',
    ],
    facets: {
      'authors.enum': { type: 'value' }
    },
  },
  apiConnector: new ElasticsearchAPIConnector(elasticPrimaryConfig),
});

const InsightsListingMain = ({ numberToShow, baseUrl }: Props) => {
  const config = elasticConfig(numberToShow);

  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ results, isLoading }) => ({ results, isLoading })}>
        {({ results, isLoading }: { results: ElasticBlogResult[], isLoading: boolean }) => {

          const groupsOfThree = results.reduce((acc: ElasticBlogResult[][], curr, index) => {
            if (index % 3 === 0) acc.push([]);
            acc[acc.length - 1].push(curr);
            return acc;
          }, []);

          return (
            <ErrorBoundary>
              <Layout
                bodyContent={
                  <div className="p-post-archive__container">
                    {isLoading ? (
                      <div>Loading...</div> // TODO: Maybe set up a skeleton loader here or at least get the div a height to prevent layout shift 
                    ) : ( 
                      groupsOfThree.map((posts, index) => (
                        <InsightsRow key={index} posts={posts} baseUrl={baseUrl} alignment={index === 0 ? 'left' : 'right'} />
                      )
                      ))}
                  </div>
                  
                }
              />
              {/* The Featured Panel is commented out to prevent it from rendering in production. */}
              {/*{latestPost && <FeaturedPanel post={latestPost} baseUrl={baseUrl} />}*/}
            </ErrorBoundary>
          )
        }}
      </WithSearch>
    </SearchProvider>
  );
};

export default InsightsListingMain;
